// Croqui: `components/Select.tsx` (maquete: `Input` com chevron). Aqui é um `<select>`
// nativo, teclado, leitor de tela e roda do celular vêm de graça, e é o que
// `spec/24` §4 item 4 pede no lugar do `DateRangeFilter` em 390px.
//
// O `Select` do Radix (`components/ui/select.tsx`) continua para menu com conteúdo rico.

import type { ReactNode, Ref, SelectHTMLAttributes } from 'react';
import { cn } from '../../lib/cn.ts';
import { Icon } from './icon.tsx';

export function Select({
  children,
  small = false,
  className,
  ref,
  ...props
}: Omit<SelectHTMLAttributes<HTMLSelectElement>, 'className'> & {
  children: ReactNode;
  small?: boolean;
  className?: string;
  ref?: Ref<HTMLSelectElement>;
}) {
  return (
    <div
      className={cn(
        'relative flex min-w-0 items-center rounded-xl border border-border bg-input focus-within:border-gold focus-within:ring-[3px] focus-within:ring-gold/15',
        small ? 'h-[38px] min-h-10 text-13 sm:min-h-0' : 'h-11 text-14',
        className,
      )}
    >
      <select
        ref={ref}
        className="min-w-0 flex-1 appearance-none bg-transparent py-0 pr-9 pl-3.5 text-text outline-none disabled:cursor-not-allowed disabled:opacity-50"
        {...props}
      >
        {children}
      </select>
      <Icon
        name="chevronDown"
        size={14}
        className="pointer-events-none absolute right-3 text-muted"
      />
    </div>
  );
}
